import { Box, Card, CardProps, Typography } from "@xcorejs/ui";

export type LegalCardProps = {
  title?: string;
} & CardProps;

const LegalCard = ({ title, ...props }: LegalCardProps) => {
  return (
    <Card
      variant="outline"
      maxWidth="100%"
      body={
        <Box width="100%">
          <Typography variant="h4" display="block" textAlign="center" width="100%">
            {title}
          </Typography>
        </Box>
      }
      _body={{
        padding: { _: "2rem", sm: "3rem" },
      }}
      _hover={{ border: "2px solid rgba(69, 86, 99, 0.75)" }}
      transition="border 300ms"
      {...props}
    />
  );
};

export default LegalCard;
